export const YYYY_MM_DD_ISO = new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(([+-]\d+(:\d+)?)|[zZ])?$/i);
export const DD_MM_YYYY_BAR = new RegExp(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i);
export const MM_DD_YYYY_BAR = new RegExp(/^(((0)[0-9])|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4}$/i);
export const YYYY_MM_DD_HIFEN = new RegExp(/^\d{4}(-)(((0)[0-9])|((1)[0-2]))(-)([0-2][0-9]|(3)[0-1])$/i);
export const YYYY_MM_DD_HH_MM_SS = new RegExp(/^\d{4}(-)(((0)[0-9])|((1)[0-2]))(-)([0-2][0-9]|(3)[0-1])(\s)(2[0-3]|[01][0-9])?(:(\d+))?(:(\d+))?(.(\d+))$/i);

export const getTypeDate = (value, dateFormat) => {
	const format = dateFormat || Realize.i18n.t('date.formats.date');

	if (value === undefined || value === null || value === "")
		return "invalid";

	if (YYYY_MM_DD_ISO.test(value))
		return "ISO";

	if (DD_MM_YYYY_BAR.test(value) || MM_DD_YYYY_BAR.test(value))
		return format;

	if (YYYY_MM_DD_HIFEN.test(value))
		return "YYYY-MM-DD";

	if (YYYY_MM_DD_HH_MM_SS.test(value))
		return "YYYY-MM-DD HH:mm:ss";

	if (typeof value === "number")
		return "number";

	return "invalid";
}

export const formatDateToBasic = (value, dateFormat) => {
	const typeDate = getTypeDate(value, dateFormat);

	if (typeDate === "invalid")
		return null;

	if (typeDate === "ISO") {
		const dateSplitted = value.split("-");

		if (dateFormat === "DD/MM/YYYY" || !dateFormat)
			return `${dateSplitted[2].split("T")[0]}/${dateSplitted[1]}/${dateSplitted[0]}`;
		else if (dateFormat === "MM/DD/YYYY")
			return `${dateSplitted[1]}/${dateSplitted[2].split("T")[0]}/${dateSplitted[0]}`;
		else if (dateFormat === "YYYY-MM-DD")
			return `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2].split("T")[0]}`;
		else if (dateFormat === "DD/MM/YYYY HH" || dateFormat === "DD/MM/YYYY HH:mm" || dateFormat === "DD/MM/YYYY HH:mm:ss")
			return `${dateSplitted[2].split("T")[0]}/${dateSplitted[1]}/${dateSplitted[0]}`;
		else if (dateFormat === "MM/DD/YYYY HH" || dateFormat === "MM/DD/YYYY HH:mm" || dateFormat === "MM/DD/YYYY HH:mm:ss")
			return `${dateSplitted[1]}/${dateSplitted[2].split("T")[0]}/${dateSplitted[0]}`;
	}

	if (typeDate === "YYYY-MM-DD") {
		const dateSplitted = value.split("-");

		if (!dateFormat) {
			const currentLocale = Realize.i18n.currentLocale.toLowerCase();

			if (currentLocale === 'pt-br' || currentLocale === 'es') {
				return `${dateSplitted[2]}/${dateSplitted[1]}/${dateSplitted[0]}`;
			}
			else {
				return `${dateSplitted[1]}/${dateSplitted[2]}/${dateSplitted[0]}`;
			}
		}
		else if (dateFormat === "DD/MM/YYYY")
			return `${dateSplitted[2]}/${dateSplitted[1]}/${dateSplitted[0]}`;
		else if (dateFormat === "MM/DD/YYYY")
			return `${dateSplitted[1]}/${dateSplitted[2]}/${dateSplitted[0]}`;
		else if (dateFormat === "YYYY-MM-DD")
			return value;
		else if (dateFormat === "DD/MM/YYYY HH" || dateFormat === "DD/MM/YYYY HH:mm" || dateFormat === "DD/MM/YYYY HH:mm:ss")
			return `${dateSplitted[2]}/${dateSplitted[1]}/${dateSplitted[0]}`;
		else if (dateFormat === "MM/DD/YYYY HH" || dateFormat === "MM/DD/YYYY HH:mm" || dateFormat === "MM/DD/YYYY HH:mm:ss")
			return `${dateSplitted[1]}/${dateSplitted[2]}/${dateSplitted[0]}`;
	}

	if (typeDate === "YYYY-MM-DD HH:mm:ss") {
		const dateSplitted = value.split(" ");
		const dateWithoutSplitted = dateSplitted[0].split("-");

		if (dateFormat === "DD/MM/YYYY" || !dateFormat)
			return `${dateWithoutSplitted[2]}/${dateWithoutSplitted[1]}/${dateWithoutSplitted[0]}`;
		else if (dateFormat === "MM/DD/YYYY")
			return `${dateWithoutSplitted[1]}/${dateWithoutSplitted[2]}/${dateWithoutSplitted[0]}`;
		else if (dateFormat === "YYYY-MM-DD")
			return `${dateWithoutSplitted[0]}-${dateWithoutSplitted[1]}-${dateWithoutSplitted[2]}`;
		else if (dateFormat === "DD/MM/YYYY HH" || dateFormat === "DD/MM/YYYY HH:mm" || dateFormat === "DD/MM/YYYY HH:mm:ss")
			return `${dateWithoutSplitted[2]}/${dateWithoutSplitted[1]}/${dateWithoutSplitted[0]} ${dateSplitted[1]}`;
		else if (dateFormat === "MM/DD/YYYY HH" || dateFormat === "MM/DD/YYYY HH:mm" || dateFormat === "MM/DD/YYYY HH:mm:ss")
			return `${dateWithoutSplitted[1]}/${dateWithoutSplitted[2]}/${dateWithoutSplitted[0]} ${dateSplitted[1]}`;
	}

	if (typeDate === "number") {
		const dateConverted = new Date(value);
		const day = dateConverted.getDate();
		const month = dateConverted.getMonth() + 1;
		const year = dateConverted.getFullYear();
		const dateSplitted = (`${year}-${month <= 9 ? `0${month}` : month}-${day <= 9 ? `0${day}` : day}T00:00:00.000Z`).split("-");

		if (dateFormat === "DD/MM/YYYY" || !dateFormat)
			return `${dateSplitted[2].split("T")[0]}/${dateSplitted[1]}/${dateSplitted[0]}`;
		else if (dateFormat === "MM/DD/YYYY")
			return `${dateSplitted[1]}/${dateSplitted[2].split("T")[0]}/${dateSplitted[0]}`;
		else if (dateFormat === "YYYY-MM-DD")
			return `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2].split("T")[0]}`;
		else if (dateFormat === "DD/MM/YYYY HH" || dateFormat === "DD/MM/YYYY HH:mm" || dateFormat === "DD/MM/YYYY HH:mm:ss")
			return `${dateSplitted[2].split("T")[0]}/${dateSplitted[1]}/${dateSplitted[0]}`;
		else if (dateFormat === "MM/DD/YYYY HH" || dateFormat === "MM/DD/YYYY HH:mm" || dateFormat === "MM/DD/YYYY HH:mm:ss")
			return `${dateSplitted[1]}/${dateSplitted[2].split("T")[0]}/${dateSplitted[0]}`;
	}

	return value;
}

export const formatDateToISO = (value, dateFormat) => {
	const typeDate = getTypeDate(value, dateFormat);

	if (typeDate === "invalid")
		return null;

	if (typeDate === "ISO") {
		const dateSplitted = value.split("T");
		return `${dateSplitted[0]}T00:00:00.000Z`;
	}

	if (typeDate === "DD/MM/YYYY") {
		const dateSplitted = value.split("/");
		return `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}T00:00:00.000Z`;
	}

	if (typeDate === "MM/DD/YYYY") {
		const dateSplitted = value.split("/");
		return `${dateSplitted[2]}-${dateSplitted[0]}-${dateSplitted[1]}T00:00:00.000Z`;
	}

	if (typeDate === "YYYY-MM-DD") {
		const dateSplitted = value.split("-");
		return `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}T00:00:00.000Z`;
	}

	if (typeDate === "number") {
		const dateConverted = new Date(value);
		const day = dateConverted.getDate();
		const month = dateConverted.getMonth() + 1;
		const year = dateConverted.getFullYear();
		return `${year}-${month <= 9 ? `0${month}` : month}-${day <= 9 ? `0${day}` : day}T00:00:00.000Z`;
	}

	return value;
}
